<pr-quick-chart-bar
  [items]="items$ | async"
  [hotkeyMap]="hotkeyMap"
  (chartableAdded)="optionSelected($event)"
 />
